import React from 'react';
import { Submission } from 'types/evaluation';
import { refreshAzureBlobUrl } from 'utils/azure';

interface VideoTabProps {
  submission: Submission;
  submissionId: string;
  loadingStates: Record<string, boolean>;
  handleMediaLoad: (submissionId: string, mediaType: string) => void;
}

const VideoTab: React.FC<VideoTabProps> = ({
  submission,
  submissionId,
  loadingStates,
  handleMediaLoad,
}) => {
  return (
    <div>
      <h3 className="text-xl font-baijamjuree font-extrabold text-black mb-6">
        Video Submission
      </h3>

      {/* Large Video Player */}
      <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner relative">
        {/* Loading Overlay */}
        {loadingStates[`${submissionId}_video`] && (
          <div className="absolute inset-0 bg-gray-900 flex items-center justify-center z-10">
            <div className="text-center">
              <div className="animate-spin h-12 w-12 border-4 border-purple-500 border-t-transparent rounded-full mx-auto mb-4"></div>
              <p className="text-white font-baijamjuree font-semibold">
                Loading Video...
              </p>
              <p className="text-gray-300 font-baijamjuree text-sm mt-2">
                Preparing for smooth playback
              </p>
            </div>
          </div>
        )}

        <video
          controls
          className="w-full h-[50vh] min-h-[400px] max-h-[600px] object-contain"
          preload="auto"
          controlsList="nodownload"
          onLoadedData={() => handleMediaLoad(submissionId, 'video')}
          onCanPlay={() => handleMediaLoad(submissionId, 'video')}
        >
          <source
            src={refreshAzureBlobUrl(submission.video_url)}
            type="video/mp4"
          />
          <source
            src={refreshAzureBlobUrl(submission.video_url)}
            type="video/mov"
          />
          <source
            src={refreshAzureBlobUrl(submission.video_url)}
            type="video/wmv"
          />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Video Information */}
      <div className="mt-4 text-center">
        <p className="text-gray-600 font-baijamjuree text-sm">
          Video automatically adjusts to your screen size. Use fullscreen for
          the best viewing experience.
        </p>
      </div>
    </div>
  );
};

export default VideoTab;
